// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper--JJ4ZtqnKY53aTUKK","text":"text--fVgXcNgKDmkahVF6"};